const ProgressValue = {};
export default ProgressValue;

ProgressValue.STARTED = "started";
ProgressValue.COMPLETED = "completed";